// Generated by purs version 0.15.12
import * as $foreign from "./foreign.js";
import * as Affjax from "../Affjax/index.js";
import * as Affjax_ResponseFormat from "../Affjax.ResponseFormat/index.js";
import * as Affjax_Web from "../Affjax.Web/index.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Error_Class from "../Control.Monad.Error.Class/index.js";
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as Control_Monad_Fork_Class from "../Control.Monad.Fork.Class/index.js";
import * as Control_Monad_ST_Class from "../Control.Monad.ST.Class/index.js";
import * as Control_Monad_Trans_Class from "../Control.Monad.Trans.Class/index.js";
import * as Data_AppFiber from "../Data.AppFiber/index.js";
import * as Data_Argonaut_Core from "../Data.Argonaut.Core/index.js";
import * as Data_Argonaut_Decode_Class from "../Data.Argonaut.Decode.Class/index.js";
import * as Data_Argonaut_Decode_Parser from "../Data.Argonaut.Decode.Parser/index.js";
import * as Data_Argonaut_Encode_Class from "../Data.Argonaut.Encode.Class/index.js";
import * as Data_Bifunctor from "../Data.Bifunctor/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Lens_Getter from "../Data.Lens.Getter/index.js";
import * as Data_Lens_Internal_Forget from "../Data.Lens.Internal.Forget/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_TcpStatsResult from "../Data.TcpStatsResult/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Effect_Aff from "../Effect.Aff/index.js";
import * as Effect_Aff_Class from "../Effect.Aff.Class/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Effect_Class_Console from "../Effect.Class.Console/index.js";
import * as Effect_Exception from "../Effect.Exception/index.js";
import * as Fusion_Data_FSError from "../Fusion.Data.FSError/index.js";
import * as Fusion_Dev from "../Fusion.Dev/index.js";
import * as Fusion_Foreign_JsSDK from "../Fusion.Foreign.JsSDK/index.js";
import * as Fusion_Generator from "../Fusion.Generator/index.js";
import * as Fusion_MonadWebsocket from "../Fusion.MonadWebsocket/index.js";
import * as Fusion_ParAff from "../Fusion.ParAff/index.js";
import * as MST_Data_BasicURL from "../MST.Data.BasicURL/index.js";
import * as URI_Scheme from "../URI.Scheme/index.js";
import * as WE_Class_AVar from "../WE.Class.AVar/index.js";
import * as WE_Class_MonadRef from "../WE.Class.MonadRef/index.js";
import * as WE_Class_Random from "../WE.Class.Random/index.js";
import * as WE_Class_Time from "../WE.Class.Time/index.js";
import * as Web_HTML from "../Web.HTML/index.js";
import * as Web_HTML_Window from "../Web.HTML.Window/index.js";
var monadThrowExceptT = /* #__PURE__ */ Control_Monad_Except_Trans.monadThrowExceptT(Effect_Aff.monadAff);
var monadEffectExceptT = /* #__PURE__ */ Control_Monad_Except_Trans.monadEffectExceptT(Effect_Aff.monadEffectAff);
var bind = /* #__PURE__ */ Control_Bind.bind(Effect_Aff.bindAff);
var pure = /* #__PURE__ */ Control_Applicative.pure(Effect_Aff.applicativeAff);
var lift = /* #__PURE__ */ Control_Monad_Trans_Class.lift(Control_Monad_Except_Trans.monadTransExceptT)(Effect_Aff.monadAff);
var monadAffExceptT = /* #__PURE__ */ Effect_Aff_Class.monadAffExceptT(Effect_Aff_Class.monadAffAff);
var functorExceptT = /* #__PURE__ */ Control_Monad_Except_Trans.functorExceptT(Effect_Aff.functorAff);
var bindExceptT = /* #__PURE__ */ Control_Monad_Except_Trans.bindExceptT(Effect_Aff.monadAff);
var map = /* #__PURE__ */ Data_Functor.map(functorExceptT);
var withExceptT = /* #__PURE__ */ Control_Monad_Except_Trans.withExceptT(Effect_Aff.functorAff);
var applicativeExceptT = /* #__PURE__ */ Control_Monad_Except_Trans.applicativeExceptT(Effect_Aff.monadAff);
var lmap = /* #__PURE__ */ Data_Bifunctor.lmap(Data_Bifunctor.bifunctorEither);
var gDecodeJsonCons = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString));
var gDecodeJsonCons1 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons(/* #__PURE__ */ gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Data_TcpStatsResult.decodeJsonTcpInfo))(Data_Argonaut_Decode_Class.gDecodeJsonNil)({
    reflectSymbol: function () {
        return "tcpInfo";
    }
})()())({
    reflectSymbol: function () {
        return "kernelVersion";
    }
})()())({
    reflectSymbol: function () {
        return "kernelName";
    }
})()())()));
var decodeJson = /* #__PURE__ */ Data_Argonaut_Decode_Class.decodeJson(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons1(/* #__PURE__ */ gDecodeJsonCons1(Data_Argonaut_Decode_Class.gDecodeJsonNil)({
    reflectSymbol: function () {
        return "startStats";
    }
})()())({
    reflectSymbol: function () {
        return "latestStats";
    }
})()())());
var throwError = /* #__PURE__ */ Control_Monad_Error_Class.throwError(Effect_Aff.monadThrowAff);
var show = /* #__PURE__ */ Data_Show.show(Fusion_Data_FSError.showFSError);
var catchError = /* #__PURE__ */ Control_Monad_Error_Class.catchError(Effect_Aff.monadErrorAff);
var bind1 = /* #__PURE__ */ Control_Bind.bind(bindExceptT);
var pure1 = /* #__PURE__ */ Control_Applicative.pure(applicativeExceptT);
var show1 = /* #__PURE__ */ Data_Show.show(Effect_Exception.showError);
var liftEither = /* #__PURE__ */ Control_Monad_Error_Class.liftEither(monadThrowExceptT);
var unimplemented = /* #__PURE__ */ Fusion_Dev.unimplemented();
var liftEffect = /* #__PURE__ */ Effect_Class.liftEffect(Effect_Aff.monadEffectAff);
var map1 = /* #__PURE__ */ Data_Functor.map(Effect_Aff.functorAff);
var liftAff = /* #__PURE__ */ Effect_Aff_Class.liftAff(monadAffExceptT);
var $$void = /* #__PURE__ */ Data_Functor["void"](Effect_Aff.functorAff);
var bind3 = /* #__PURE__ */ Control_Bind.bind(Data_Either.bindEither);
var _scheme = /* #__PURE__ */ MST_Data_BasicURL["_scheme"](Data_Lens_Internal_Forget.strongForget);
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit);
var eq1 = /* #__PURE__ */ Data_Eq.eq(URI_Scheme.eqScheme);
var $$try = /* #__PURE__ */ Control_Monad_Error_Class["try"](Control_Monad_Error_Class.monadErrorEffect);
var put = /* #__PURE__ */ WE_Class_MonadRef.put(WE_Class_MonadRef.monadRefRefEffect);
var AppM = function (x) {
    return x;
};
var monadTimeAppM = /* #__PURE__ */ WE_Class_Time.monadTimeExceptT(WE_Class_Time.monadTimeAff);
var monadThrowAppM = monadThrowExceptT;
var throwError1 = /* #__PURE__ */ Control_Monad_Error_Class.throwError(monadThrowAppM);
var monadRefRefAppM = /* #__PURE__ */ WE_Class_MonadRef.monadRefExceptT(WE_Class_MonadRef.monadRefRefAff);
var $$new = /* #__PURE__ */ WE_Class_MonadRef["new"](monadRefRefAppM);
var read = /* #__PURE__ */ WE_Class_MonadRef.read(monadRefRefAppM);
var put1 = /* #__PURE__ */ WE_Class_MonadRef.put(monadRefRefAppM);
var monadRecAppM = /* #__PURE__ */ Control_Monad_Except_Trans.monadRecExceptT(Effect_Aff.monadRecAff);
var monadRandomAppM = /* #__PURE__ */ WE_Class_Random.monadRandomExceptT(WE_Class_Random.monadRandomAff);
var monadLogAppMFSError = {
    log: /* #__PURE__ */ (function () {
        var $248 = Effect_Class_Console.log(monadEffectExceptT);
        return function ($249) {
            return AppM($248($249));
        };
    })()
};
var monadErrorAppM = /* #__PURE__ */ Control_Monad_Except_Trans.monadErrorExceptT(Effect_Aff.monadAff);
var monadEffectAppM = monadEffectExceptT;
var liftEffect1 = /* #__PURE__ */ Effect_Class.liftEffect(monadEffectAppM);
var monadCancelAppM = {
    cancelWith: function (v) {
        return function (v1) {
            return Effect_Aff.cancelWith(Control_Monad_Except_Trans.runExceptT(v))(function (v2) {
                return bind(Control_Monad_Except_Trans.runExceptT(v1))(function (v3) {
                    if (v3 instanceof Data_Either.Left) {
                        return pure(Data_Unit.unit);
                    };
                    if (v3 instanceof Data_Either.Right) {
                        return pure(Data_Unit.unit);
                    };
                    throw new Error("Failed pattern match at Fusion.Impl.AppM (line 162, column 50 - line 164, column 31): " + [ v3.constructor.name ]);
                });
            });
        };
    }
};
var monadAppM = /* #__PURE__ */ Control_Monad_Except_Trans.monadExceptT(Effect_Aff.monadAff);
var monadSTGlobalAppM = {
    liftST: /* #__PURE__ */ (function () {
        var $250 = Control_Monad_ST_Class.liftST(Effect_Aff.monadSTAff);
        return function ($251) {
            return AppM(lift($250($251)));
        };
    })(),
    Monad0: function () {
        return monadAppM;
    }
};
var monadAffAppM = monadAffExceptT;
var liftAff1 = /* #__PURE__ */ Effect_Aff_Class.liftAff(monadAffAppM);
var manageAVarAVarAppM = /* #__PURE__ */ WE_Class_AVar.manageAVarExceptT(WE_Class_AVar.manageAVarAVarAff);
var empty = /* #__PURE__ */ WE_Class_AVar.empty(manageAVarAVarAppM);
var put2 = /* #__PURE__ */ WE_Class_AVar.put(manageAVarAVarAppM);
var take = /* #__PURE__ */ WE_Class_AVar.take(manageAVarAVarAppM);
var functorAppM = functorExceptT;
var functorAppFiber = /* #__PURE__ */ Data_AppFiber.functorAppFiber(functorAppM);
var bindAppM = bindExceptT;
var bind4 = /* #__PURE__ */ Control_Bind.bind(bindAppM);
var discard2 = /* #__PURE__ */ discard(bindAppM);
var bifunctorAppM = {
    bimap: function (mapLeft) {
        return function (mapRight) {
            return function (v) {
                return map(mapRight)(withExceptT(mapLeft)(v));
            };
        };
    }
};
var applyAppM = /* #__PURE__ */ Control_Monad_Except_Trans.applyExceptT(Effect_Aff.monadAff);
var applicativeAppM = applicativeExceptT;
var pure3 = /* #__PURE__ */ Control_Applicative.pure(applicativeAppM);
var unless = /* #__PURE__ */ Control_Applicative.unless(applicativeAppM);
var monadFetchTcpStatsAppMFSE = function (dictMonadThrow) {
    var throwError2 = Control_Monad_Error_Class.throwError(dictMonadThrow);
    var liftEither1 = Control_Monad_Error_Class.liftEither(dictMonadThrow);
    return {
        fetchTcpStats: function (url) {
            return bind4(bind4(liftAff1(Affjax_Web.get(Affjax_ResponseFormat.json)(MST_Data_BasicURL.print(url))))(function (v) {
                if (v instanceof Data_Either.Left) {
                    return throwError2(Fusion_Data_FSError.mk(Fusion_Data_FSError.StCn50.value)("Failed to fetch TCP stats: " + Affjax.printError(v.value0)));
                };
                if (v instanceof Data_Either.Right) {
                    return pure3(v.value0);
                };
                throw new Error("Failed pattern match at Fusion.Impl.AppM (line 252, column 13 - line 254, column 30): " + [ v.constructor.name ]);
            }))(function (v) {
                return bind4(liftEither1(lmap(Fusion_Data_FSError.fromJsonDecodeError(Fusion_Data_FSError.StRe50.value)(v.body))(decodeJson(v.body))))(function (v1) {
                    return pure3(Data_TcpStatsResult.toTranmissionStatsResult(v1));
                });
            });
        }
    };
};
var monadFetchTcpStatsAppMFSE1 = /* #__PURE__ */ monadFetchTcpStatsAppMFSE(monadThrowAppM);
var unAppM = function (v) {
    return v;
};
var runAppM = function (v) {
    return Control_Monad_Except_Trans.runExceptT(v);
};
var runAppMinAff = function (ma) {
    return bind(runAppM(ma))(function (result) {
        if (result instanceof Data_Either.Left) {
            return throwError(Effect_Exception.error(show(result.value0)));
        };
        if (result instanceof Data_Either.Right) {
            return pure(result.value0);
        };
        throw new Error("Failed pattern match at Fusion.Impl.AppM (line 213, column 3 - line 215, column 30): " + [ result.constructor.name ]);
    });
};
var monadForkAppFiberAppMFSEr = {
    join: function (v) {
        var isCancellationException = function (err) {
            return Effect_Exception.message(err) === "CancellationException";
        };
        return bind(catchError(runAppM(v.join))(function (jsErr) {
            var $205 = isCancellationException(jsErr);
            if ($205) {
                return pure(new Data_Either.Left(Fusion_Generator.cancellationExceptionFSE));
            };
            return throwError(jsErr);
        }))(function (result) {
            return pure(result);
        });
    },
    fork: function (v) {
        var result1 = Control_Monad_Except_Trans.runExceptT(v);
        return bind1(lift(Effect_Aff.forkAff(result1)))(function (v1) {
            var result2 = Effect_Aff.joinFiber(v1);
            return pure1({
                join: result2,
                kill: lift(Effect_Aff.killFiber(Fusion_Generator.cancellationException)(v1))
            });
        });
    },
    suspend: function (v) {
        var result1 = Control_Monad_Except_Trans.runExceptT(v);
        return bind1(lift(Effect_Aff.suspendAff(result1)))(function (v1) {
            var result2 = Effect_Aff.joinFiber(v1);
            return pure1({
                join: result2,
                kill: lift(Effect_Aff.killFiber(Fusion_Generator.cancellationException)(v1))
            });
        });
    },
    Monad0: function () {
        return monadAppM;
    },
    Functor1: function () {
        return functorAppFiber;
    }
};
var monadKillFSErrorAppFiberA = {
    kill: function (v) {
        return function (v1) {
            return v1.kill;
        };
    },
    MonadFork0: function () {
        return monadForkAppFiberAppMFSEr;
    },
    MonadThrow1: function () {
        return monadThrowAppM;
    }
};
var monadBracketFSErrorAppFib = {
    bracket: function (v) {
        return function (cleanup) {
            return function (action) {
                return bind1(v)(function (v1) {
                    return bind1(lift(Effect_Aff.generalBracket(pure(v1))({
                        completed: function (v2) {
                            return function (v3) {
                                if (v2 instanceof Data_Either.Right) {
                                    return bind(runAppM(cleanup(new Control_Monad_Fork_Class.Completed(v2.value0))(v3)))(function () {
                                        return pure(Data_Unit.unit);
                                    });
                                };
                                if (v2 instanceof Data_Either.Left) {
                                    return bind(runAppM(cleanup(new Control_Monad_Fork_Class.Failed(v2.value0))(v1)))(function () {
                                        return pure(Data_Unit.unit);
                                    });
                                };
                                throw new Error("Failed pattern match at Fusion.Impl.AppM (line 174, column 60 - line 180, column 24): " + [ v2.constructor.name ]);
                            };
                        },
                        failed: function (v2) {
                            return function (v3) {
                                return bind(runAppM(cleanup(new Control_Monad_Fork_Class.Failed(Fusion_Data_FSError.mk(Fusion_Data_FSError.Cl54.value)("JsError: " + show1(v2))))(v3)))(function () {
                                    return pure(Data_Unit.unit);
                                });
                            };
                        },
                        killed: function (v2) {
                            return function (v3) {
                                return bind(runAppM(cleanup(new Control_Monad_Fork_Class.Killed(Fusion_Generator.cancellationExceptionFSE))(v3)))(function () {
                                    return pure(Data_Unit.unit);
                                });
                            };
                        }
                    })(function (resource_) {
                        return bind(runAppM(action(resource_)))(function (v2) {
                            return pure(v2);
                        });
                    })))(function (v2) {
                        return liftEither(v2);
                    });
                });
            };
        };
    },
    uninterruptible: unimplemented,
    never: unimplemented,
    MonadKill0: function () {
        return monadKillFSErrorAppFiberA;
    },
    MonadError1: function () {
        return monadErrorAppM;
    }
};
var bracket = /* #__PURE__ */ Control_Monad_Fork_Class.bracket(monadBracketFSErrorAppFib);
var requestAnimationFrame = /* #__PURE__ */ Effect_Aff.makeAff(function (emit) {
    return function __do() {
        var window = Web_HTML.window();
        var frameId = Web_HTML_Window.requestAnimationFrame(emit(new Data_Either.Right(Data_Unit.unit)))(window)();
        return function (v) {
            return liftEffect(Web_HTML_Window.cancelAnimationFrame(frameId)(window));
        };
    };
});
var parOneOfFusionAff = function (dictTraversable) {
    var parOneOf = Fusion_ParAff.parOneOf(dictTraversable.Foldable1());
    return function (dictFunctorWithIndex) {
        var Functor0 = dictFunctorWithIndex.Functor0();
        var map2 = Data_Functor.map(Functor0);
        var parOneOf1 = parOneOf(Functor0);
        return function (dictEq) {
            return function (actions) {
                var ea = map2(function (v) {
                    return Control_Monad_Except_Trans.runExceptT(v);
                })(actions);
                var firstResult = parOneOf1(ea);
                return bind4(liftAff1(firstResult))(function (v) {
                    if (v instanceof Data_Either.Left) {
                        return throwError1(v.value0);
                    };
                    if (v instanceof Data_Either.Right) {
                        return pure3(v.value0);
                    };
                    throw new Error("Failed pattern match at Fusion.Impl.AppM (line 282, column 3 - line 284, column 22): " + [ v.constructor.name ]);
                });
            };
        };
    };
};
var monadRaceInParallelAppMFS = {
    parOneOf: function (dictTraversable) {
        var parOneOfFusionAff1 = parOneOfFusionAff(dictTraversable);
        return function (dictFunctorWithIndex) {
            var parOneOfFusionAff2 = parOneOfFusionAff1(dictFunctorWithIndex);
            return function (dictEq) {
                return parOneOfFusionAff2(dictEq);
            };
        };
    }
};
var monadAppNEAppMFSError = {
    MonadFork0: function () {
        return monadForkAppFiberAppMFSEr;
    },
    MonadRec1: function () {
        return monadRecAppM;
    },
    MonadTime2: function () {
        return monadTimeAppM;
    },
    ManageAVar3: function () {
        return manageAVarAVarAppM;
    },
    MonadRef4: function () {
        return monadRefRefAppM;
    },
    MonadRandom5: function () {
        return monadRandomAppM;
    },
    MonadFetchTcpStats6: function () {
        return monadFetchTcpStatsAppMFSE1;
    },
    MonadRaceInParallel7: function () {
        return monadRaceInParallelAppMFS;
    }
};
var mkJsSDKInterfaceProd = function (sdk) {
    var convertGen = (function () {
        var $252 = map1(Fusion_Generator.mapNat(function ($254) {
            return AppM(liftAff($254));
        }));
        return function ($253) {
            return AppM(liftAff($252($253)));
        };
    })();
    var convertFn = function ($255) {
        return AppM(Control_Monad_Except_Trans.ExceptT($255));
    };
    return {
        prepare: function (opts) {
            return convertFn(Fusion_Foreign_JsSDK.prepare(sdk)(opts));
        },
        benchmark: (function () {
            var $256 = Fusion_Foreign_JsSDK.benchmark(sdk);
            return function ($257) {
                return convertGen($256($257));
            };
        })(),
        calcDownload: (function () {
            var $258 = Fusion_Foreign_JsSDK.calcDownload(sdk);
            return function ($259) {
                return convertFn($258($259));
            };
        })(),
        calcUpload: (function () {
            var $260 = Fusion_Foreign_JsSDK.calcUpload(sdk);
            return function ($261) {
                return convertFn($260($261));
            };
        })(),
        ping: (function () {
            var $262 = Fusion_Foreign_JsSDK.ping(sdk);
            return function ($263) {
                return convertGen($262($263));
            };
        })(),
        complete: (function () {
            var $264 = Fusion_Foreign_JsSDK.complete(sdk);
            return function ($265) {
                return convertFn($264($265));
            };
        })(),
        abort: (function () {
            var $266 = Fusion_Foreign_JsSDK.abort(sdk);
            return function ($267) {
                return convertFn($266($267));
            };
        })(),
        modem: (function () {
            var $268 = Fusion_Foreign_JsSDK.modem(sdk);
            return function ($269) {
                return convertGen($268($269));
            };
        })()
    };
};
var launchAppM_ = function (ma) {
    return Effect_Aff.launchAff_($$void(runAppM(ma)));
};
var encodeStr = function (dictEncodeJson) {
    var $270 = Data_Argonaut_Encode_Class.encodeJson(dictEncodeJson);
    return function ($271) {
        return Data_Argonaut_Core.stringify($270($271));
    };
};
var decodeStr = function (dictDecodeJson) {
    var decodeJson1 = Data_Argonaut_Decode_Class.decodeJson(dictDecodeJson);
    return function (str) {
        return bind3(Data_Argonaut_Decode_Parser.parseJson(str))(decodeJson1);
    };
};
var monadWebsocketsAppMFSErro = {
    createWs: function (dictEncodeJson) {
        var encodeStr1 = encodeStr(dictEncodeJson);
        return function (dictDecodeJson) {
            var decodeStr1 = decodeStr(dictDecodeJson);
            return function (url) {
                return function (emit) {
                    var schemeWs = URI_Scheme.unsafeFromString("ws");
                    var schemeWss = URI_Scheme.unsafeFromString("wss");
                    var scheme = Data_Lens_Getter.view(_scheme)(url);
                    return discard2(unless(eq1(scheme)(schemeWs) || eq1(scheme)(schemeWss))(throwError1(Fusion_Data_FSError.mk(Fusion_Data_FSError.PnCn55.value)("Invalid scheme. Supported: ws and wss"))))(function () {
                        return bind4(empty)(function (avReady) {
                            return bind4($$new(false))(function (refIsOpen) {
                                return bind4(liftEffect1($$try(function () {
                                    return $foreign.createWsImpl(MST_Data_BasicURL.print(url), {
                                        onOpen: function __do() {
                                            launchAppM_(put2(new Data_Either.Right(Data_Unit.unit))(avReady))();
                                            return put(refIsOpen)(true)();
                                        },
                                        onMessage: function (str) {
                                            return launchAppM_(emit((function () {
                                                var v = decodeStr1(str);
                                                if (v instanceof Data_Either.Left) {
                                                    return new Fusion_MonadWebsocket.WsError(new Fusion_MonadWebsocket.WsDecodeError(v.value0));
                                                };
                                                if (v instanceof Data_Either.Right) {
                                                    return new Fusion_MonadWebsocket.WsMessage(v.value0);
                                                };
                                                throw new Error("Failed pattern match at Fusion.Impl.AppM (line 327, column 13 - line 329, column 41): " + [ v.constructor.name ]);
                                            })()))();
                                        },
                                        onClose: function (err) {
                                            return launchAppM_(bind4(read(refIsOpen))(function (isOpen) {
                                                return discard2((function () {
                                                    if (isOpen) {
                                                        return emit(new Fusion_MonadWebsocket.WsClose(err));
                                                    };
                                                    return put2(new Data_Either.Left(Data_Unit.unit))(avReady);
                                                })())(function () {
                                                    return put1(refIsOpen)(false);
                                                });
                                            }))();
                                        },
                                        onError: launchAppM_(bind4(read(refIsOpen))(function (isOpen) {
                                            return discard2((function () {
                                                if (isOpen) {
                                                    return emit(new Fusion_MonadWebsocket.WsError(Fusion_MonadWebsocket.WsConnectionError.value));
                                                };
                                                return put2(new Data_Either.Left(Data_Unit.unit))(avReady);
                                            })())(function () {
                                                return put1(refIsOpen)(false);
                                            });
                                        }))
                                    });
                                })))(function (eitherIfc) {
                                    if (eitherIfc instanceof Data_Either.Left) {
                                        return throwError1(Fusion_Data_FSError.mk(Fusion_Data_FSError.PnCn51.value)("Failed to create websocket: JS Error: " + Effect_Exception.message(eitherIfc.value0)));
                                    };
                                    if (eitherIfc instanceof Data_Either.Right) {
                                        return bracket(pure3(Data_Unit.unit))(function (cond) {
                                            return function (v) {
                                                if (cond instanceof Control_Monad_Fork_Class.Killed) {
                                                    return liftEffect1(eitherIfc.value0.cleanUp);
                                                };
                                                if (cond instanceof Control_Monad_Fork_Class.Failed) {
                                                    return liftEffect1(eitherIfc.value0.cleanUp);
                                                };
                                                if (cond instanceof Control_Monad_Fork_Class.Completed) {
                                                    return pure3(Data_Unit.unit);
                                                };
                                                throw new Error("Failed pattern match at Fusion.Impl.AppM (line 360, column 15 - line 363, column 41): " + [ cond.constructor.name ]);
                                            };
                                        })(function (v) {
                                            return bind4(take(avReady))(function (result) {
                                                if (result instanceof Data_Either.Left) {
                                                    return throwError1(Fusion_Data_FSError.mk(Fusion_Data_FSError.PnCn50.value)("Failed to create websocket"));
                                                };
                                                if (result instanceof Data_Either.Right) {
                                                    return pure3({
                                                        sendMessage: function (str) {
                                                            return liftEffect1(function () {
                                                                return eitherIfc.value0.sendMessage(encodeStr1(str));
                                                            });
                                                        },
                                                        close: liftEffect1(eitherIfc.value0.cleanUp)
                                                    });
                                                };
                                                throw new Error("Failed pattern match at Fusion.Impl.AppM (line 368, column 15 - line 375, column 20): " + [ result.constructor.name ]);
                                            });
                                        });
                                    };
                                    throw new Error("Failed pattern match at Fusion.Impl.AppM (line 352, column 5 - line 377, column 12): " + [ eitherIfc.constructor.name ]);
                                });
                            });
                        });
                    });
                };
            };
        };
    },
    Monad0: function () {
        return monadAppM;
    }
};
var monadAppFSErrorAppMFSErro = {
    MonadThrow0: function () {
        return monadThrowAppM;
    },
    MonadError1: function () {
        return monadErrorAppM;
    },
    MonadBracket2: function () {
        return monadBracketFSErrorAppFib;
    },
    MonadKill3: function () {
        return monadKillFSErrorAppFiberA;
    },
    MonadAppNE4: function () {
        return monadAppNEAppMFSError;
    },
    MonadWebsockets5: function () {
        return monadWebsocketsAppMFSErro;
    }
};
export {
    AppM,
    launchAppM_,
    mkJsSDKInterfaceProd,
    runAppM,
    runAppMinAff,
    unAppM,
    monadEffectAppM,
    monadAffAppM,
    bifunctorAppM,
    functorAppM,
    applyAppM,
    applicativeAppM,
    bindAppM,
    monadAppM,
    monadThrowAppM,
    monadErrorAppM,
    monadForkAppFiberAppMFSEr,
    monadRecAppM,
    monadTimeAppM,
    manageAVarAVarAppM,
    monadSTGlobalAppM,
    monadKillFSErrorAppFiberA,
    monadCancelAppM,
    monadBracketFSErrorAppFib,
    monadAppNEAppMFSError,
    monadAppFSErrorAppMFSErro,
    monadRefRefAppM,
    monadRandomAppM,
    monadFetchTcpStatsAppMFSE,
    monadRaceInParallelAppMFS,
    monadWebsocketsAppMFSErro,
    monadLogAppMFSError
};
